import React, { useEffect } from "react";
import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

export default function OptionSectors(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-card-optionArea").focus();
  }, []);
  return (
    <div className="div-optionArea">
      <div className="card-talent">
        <a className="title-card-talent" id="title-card-optionArea" tabIndex={13}>
          Varejo e Bens
        </a>
        <video
          width={250}
          controls
          tabIndex={14}
          onPlay={() => pointAction("PALCO2VAREJOEBENS")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/NORBERTO_VAREJO%20E%20BENS%20V2_COM_QR%20CODE%20%281%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Telecom
        </a>
        <video
          width={250}
          controls
          tabIndex={15}
          onPlay={() => pointAction("PALCO2TELECOM")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/SETORES_%20MARCO%20TELECOM%20V2_COM_QR%20CODE%20%281%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Seguros
        </a>
        <video
          width={250}
          controls
          tabIndex={16}
          onPlay={() => pointAction("PALCO2SEGUROS")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/SETORES_ALEJANDRO%20SEGUROS%20COM_QR%20CODE%20%281%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Healthcare
        </a>
        <video
          width={250}
          controls
          tabIndex={17}
          onPlay={() => pointAction("PALCO2HEALTHCARE")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/SETORES_ALEJANDRO_HEALTHCARE%20legendado%2027_12_2022%20%281%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Utilities
        </a>
        <video
          width={250}
          controls
          tabIndex={18}
          onPlay={() => pointAction("PALCO2UTILITIES")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/SETORES_RAPHAEL_UTILITIES%20COM_QR%20CODE%20%281%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Indústria
        </a>
        <video
          width={250}
          controls
          tabIndex={19}
          onPlay={() => pointAction("PALCO2INDUSTRIA")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/SETORES_SALVADOR_INDUSTRIA%20%281%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          Banking
        </a>
        <video
          width={250}
          controls
          tabIndex={20}
          onPlay={() => pointAction("PALCO2BANKING")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/SETORES/SETORES_FRANCISCO%20-%20BANKING%20COM_QR%20CODE%20%281%29.mp4" />
        </video>
      </div>
    </div>
  );
}
